import httpClient from "./http";

export const subscriptionApi = {
  getPlans: () => httpClient.get("/subscription/plans"),
  getMySubscription: () => httpClient.get("/subscription/me"),
  createCheckout: (planId) => httpClient.post("/subscription/checkout", { planId }),
  startTrial: (planId) => httpClient.post("/subscription/start-trial", { planId }),
  getTrialConfig: () => httpClient.get("/subscription/trial-config"),
  createBillingPortal: () => httpClient.post("/subscription/billing-portal"),
  buyCredits: (amount) => httpClient.post("/subscription/buy-credits", { amount }),
  setAutoReload: (data) => httpClient.patch("/subscription/auto-reload", data),
  getTransactions: (params) => httpClient.get("/subscription/transactions", { params }),
  getPayments: () => httpClient.get("/subscription/payments"),
  canSendSms: () => httpClient.get("/subscription/can-send-sms"),
  workflowsEnabled: () => httpClient.get("/subscription/workflows-enabled"),
};
